module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ee-Gc.a5f5f890.png";